if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.resetZoom = this.resetZoom.bind(this);
      }

      hide() {
        this.teardownZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ block: 'nearest', inline: 'nearest' });

        const container = this.querySelector('[role="document"]');
        if (container) container.scrollLeft = 0;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        this.setupZoom(activeMedia);
      }

      setupZoom(activeMedia) {
        this.teardownZoom();
        if (!activeMedia || window.matchMedia('(min-width: 750px)').matches) return;

        const image =
          activeMedia.tagName === 'IMG'
            ? activeMedia
            : activeMedia.querySelector('img');
        if (!image) return;

        this.zoomImage = image;
        this.zoomScale = 1;
        this.zoomX = 0;
        this.zoomY = 0;
        this.pinchStartDist = 0;
        this.pinchStartScale = 1;
        this.panStartX = 0;
        this.panStartY = 0;
        this.originX = 0;
        this.originY = 0;
        this.isPanning = false;

        image.classList.add('product-media-modal__zoom-target');
        image.style.transformOrigin = 'center center';
        this.applyZoomTransform();

        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;
        this.zoomSurface = content;
        content.addEventListener('touchstart', this.onTouchStart, { passive: false });
        content.addEventListener('touchmove', this.onTouchMove, { passive: false });
        content.addEventListener('touchend', this.onTouchEnd, { passive: true });
        content.addEventListener('touchcancel', this.onTouchEnd, { passive: true });
        content.addEventListener('dblclick', this.resetZoom);
      }

      teardownZoom() {
        if (this.zoomSurface) {
          this.zoomSurface.removeEventListener('touchstart', this.onTouchStart);
          this.zoomSurface.removeEventListener('touchmove', this.onTouchMove);
          this.zoomSurface.removeEventListener('touchend', this.onTouchEnd);
          this.zoomSurface.removeEventListener('touchcancel', this.onTouchEnd);
          this.zoomSurface.removeEventListener('dblclick', this.resetZoom);
        }
        if (this.zoomImage) {
          this.zoomImage.classList.remove('product-media-modal__zoom-target');
          this.zoomImage.style.transform = '';
          this.zoomImage.style.willChange = '';
        }
        this.zoomSurface = null;
        this.zoomImage = null;
        this.zoomScale = 1;
        this.zoomX = 0;
        this.zoomY = 0;
      }

      applyZoomTransform() {
        if (!this.zoomImage) return;
        this.zoomImage.style.willChange = 'transform';
        this.zoomImage.style.transform = `translate3d(${this.zoomX}px, ${this.zoomY}px, 0) scale(${this.zoomScale})`;
        if (this.zoomSurface) {
          this.zoomSurface.classList.toggle('is-zoomed', this.zoomScale > 1.01);
        }
      }

      touchDistance(touches) {
        const dx = touches[0].clientX - touches[1].clientX;
        const dy = touches[0].clientY - touches[1].clientY;
        return Math.hypot(dx, dy);
      }

      onTouchStart(event) {
        if (!this.zoomImage) return;
        if (event.touches.length === 2) {
          event.preventDefault();
          this.pinchStartDist = this.touchDistance(event.touches);
          this.pinchStartScale = this.zoomScale;
          this.isPanning = false;
          return;
        }
        if (event.touches.length === 1 && this.zoomScale > 1.01) {
          this.isPanning = true;
          this.panStartX = event.touches[0].clientX - this.zoomX;
          this.panStartY = event.touches[0].clientY - this.zoomY;
        }
      }

      onTouchMove(event) {
        if (!this.zoomImage) return;

        if (event.touches.length === 2 && this.pinchStartDist) {
          event.preventDefault();
          const dist = this.touchDistance(event.touches);
          const next = Math.min(4, Math.max(1, this.pinchStartScale * (dist / this.pinchStartDist)));
          this.zoomScale = next;
          if (this.zoomScale <= 1.01) {
            this.zoomScale = 1;
            this.zoomX = 0;
            this.zoomY = 0;
          }
          this.applyZoomTransform();
          return;
        }

        if (this.isPanning && event.touches.length === 1 && this.zoomScale > 1.01) {
          event.preventDefault();
          this.zoomX = event.touches[0].clientX - this.panStartX;
          this.zoomY = event.touches[0].clientY - this.panStartY;
          this.applyZoomTransform();
        }
      }

      onTouchEnd(event) {
        if (event.touches.length < 2) this.pinchStartDist = 0;
        if (event.touches.length === 0) this.isPanning = false;
        if (this.zoomScale <= 1.01) this.resetZoom();
      }

      resetZoom() {
        this.zoomScale = 1;
        this.zoomX = 0;
        this.zoomY = 0;
        this.applyZoomTransform();
      }
    }
  );
}
